import { useTranslation } from 'react-i18next'

import type { AuditModel } from '@cdab/scania/qpr/offline/models'
import { DOS_VERSION_4, DOS_VERSION_5 } from '@cdab/scania/qpr/schema'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

const StyledTdsButton = styled(TdsButton)`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    button {
      display: block;
    }
  }
`

function isSupportedDOSVersion(dosVersion: number): boolean {
  return dosVersion === DOS_VERSION_5 || dosVersion === DOS_VERSION_4
}

export function PrintAuditReportButton(props: { audit: AuditModel }) {
  const { t } = useTranslation()

  const searchParams = new URLSearchParams({
    viewCheckPoints: 'true',
    viewSummary: 'true',
    viewPerspectives: 'false'
  })

  if (!isSupportedDOSVersion(props.audit.dosVersion)) {
    return null
  }

  return (
    <a
      className='tds-u-flex-dir-col tds-u-w100'
      href={`/audit/${props.audit.id}/audit-print?${searchParams.toString()}`}
      target='_blank'
      rel='noreferrer'
    >
      <StyledTdsButton text={capitalizeFirstLetter(t('audit'))} />
    </a>
  )
}
